import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  @Input() isBlock = false;
  @Input() balance = 0;
  @Input() amount = 0;
  @Input() showBalance = true;
  @Input() showClear = false;
  @Input() isProgol = false;
  @Input() showButton = true;
  @Input() buttonText = '';
  @Input() size = 0;
  @Input() leftDate?: Date;
  @Input() progress = 1;

  @Input() showSelect = false;
  @Input() selectData: {
    value: string | number;
    text: string;
  }[] = [];

  @Output() buttonClick = new EventEmitter<boolean>();
  @Output() clearClick = new EventEmitter<boolean>();
  @Output() selectChange = new EventEmitter<string | number>();

  onClick() {
    this.buttonClick.emit(true);
  }

  onChange(value: string | number) {
    this.selectChange.emit(value);
  }

  clear() {
    this.clearClick.emit(true);
  }
}
